
export const RXDB_EQUOTE_OPPORTUNITY_SCHEMA = {
    title: 'Equote Opportunity Schema',
    version: 5,
    type: 'object',
    primaryKey: '_id',
    properties: {
        _id: { type: 'string', maxLength: 100 },
        id: { type: ['string', 'null'], maxLength: 100 },
        offlineId: { type:  ['string'], maxLength: 100 },
        creationDate: { type: 'string'},
        modificationDate: { type: 'string'},
        label: { type: ['string', 'null'] },
        client: { type: 'object' },
        employee: { type: 'object' },
        status: { type: ['string', 'null'] },
        salesFileStatus: { type: ['string', 'null'] },
        mainQuoteId: { type: ['string','null'], maxLength: 50},
        mainQuoteOfflineId: { type: ['string'], maxLength: 100 },
        eforceOpportunityId: { type: ['string', 'null'] },
        opportunityType: { type: ['string'] },
        isSynchronized: { type: ['boolean'] },
        checkPointDate: { type: ['string', 'null'], default: null}
        },
    required: ['_id','offlineId']
};

